import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./App.css";

export default function App() {
  return (
    <div className="site-root">
      {/* Single persistent background */}
      <div className="site-bg" />
      <div className="site-overlay" />

      <Swiper
        modules={[Pagination, Navigation]}
        navigation={true}
        pagination={{ clickable: true }}
        direction="vertical"
        spaceBetween={0}
        slidesPerView={1}
        speed={600}
        className="full-swiper"
      >
        {/* SLIDE 1 — HOME */}
        <SwiperSlide>
          <div className="slide-content">
            <div className="text-box">
              <span className="welcome-text">Welcome to</span>
              <h1>Felony Book Review</h1>
              <span className="tagline">tag line here</span>
            </div>
          </div>
        </SwiperSlide>

        {/* SLIDE 2 — ABOUT THE PODCAST */}
        <SwiperSlide>
          <div className="slide-content">
            <div className="text-box">
              <span className="welcome-text">The Podcast</span>
              <h1>
                Stories from<br />
                <em>Behind the Lines</em>
              </h1>
              <p className="tagline">
                Blurb about the podcast
              </p>
              <div className="platform-row">
                <span className="platform-tag">Spotify</span>
                <span className="platform-tag">Apple Podcasts</span>
                <span className="platform-tag">YouTube</span>
              </div>
            </div>
          </div>
        </SwiperSlide>

        {/* SLIDE 3 — ABOUT ME */}
        <SwiperSlide>
          <div className="slide-content">
            <div className="text-box">
              <div className="avatar-ring">
                <div className="avatar-placeholder">FBR</div>
              </div>
              <span className="welcome-text">The Host</span>
              <h1>Kellin Monroe</h1>
              <p className="tagline">
                Tell 'em about yourself big dawg
              </p>
              <div className="social-row">
                <a href="#" className="social-link">Instagram</a>
                <a href="#" className="social-link">Twitter</a>
                <a href="#" className="social-link">Contact</a>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}